import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { DayTemplateContext } from './calendar-month-view/day-template-context';
import * as moment from 'moment';
import { MonthTemplateContext } from './calendar-year-view/month-template-context';

export enum ViewMode {
    month = 'month',
    year = 'year'
}

@Component({
    selector: 'cln-calendar',
    template: require('./calendar.component.html'),
    styles: [require('./calendar.component.less')],
})
export class CalendarComponent {
    @Input() dayTemplate: TemplateRef<DayTemplateContext>;
    @Input() monthTemplate: TemplateRef<MonthTemplateContext>;
    @Input() startDate: moment.Moment;
    @Input() selectedDate: moment.Moment;
    @Input() mode: ViewMode = ViewMode.month;
    @Output() selectedDateChange = new EventEmitter<moment.Moment>();
    @Output() modeChange = new EventEmitter<ViewMode>();
    @Output() startDateChange = new EventEmitter<moment.Moment>();
    ViewMode = ViewMode;

    onDateChange(date: moment.Moment): void {
        this.selectedDate = date;
        this.selectedDateChange.emit(this.selectedDate.clone());
    }

    onMonthChanged(date: moment.Moment): void {
        this.mode = ViewMode.month;
        this.modeChange.emit(this.mode);
        this.startDate = date;
        this.startDateChange.emit(this.startDate.clone());
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/calendar/calendar/calendar.component.ts